export interface Props {
    /**
     * @title Texto do botão
     */
    label?: string
}

export default function GoToSubscribe(
    { label = 'Quero receber as ofertas de Sex Shop da Black Friday Miess' }: Props,
) {
    return (
        <div className='px-3.5 my-8'>
            <a
                className='max-w-[650px] px-3.5 py-3 mx-auto rounded-[5px] bg-red-wine text-white text-sm text-center uppercase font-bold block'
                href='#subscribe'
            >
                {label}
            </a>
        </div>
    )
}
